module.exports = __webpack_public_path__ + "img/kuza-speed-logo.1148f360.png";